import { formatWithThousandSpaces } from "@src/utils";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useEffect } from "react";

type Props = {
  from?: number;
  to: number;
  precision?: number;
};

export const AnimatedNumber = ({ from = 0, to, precision = 0 }: Props) => {
  const motionValue = useMotionValue(from);
  const springValue = useSpring(motionValue, {
    damping: 20,
    stiffness: 100,
  });

  const rounded = useTransform(springValue, (latest) =>
    latest.toFixed(precision),
  );
  const formatted = useTransform(rounded, (v) => formatWithThousandSpaces(v));

  useEffect(() => {
    if (from !== to) {
      motionValue.set(from);
      requestAnimationFrame(() => motionValue.set(to));
    } else {
      motionValue.set(to);
    }
  }, [from, to, precision]);

  return <motion.span>{formatted}</motion.span>;
};
